import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import getBackendUrl from "../../../environment/BackendService";
import {
  downloadCSV,
  fetchDataCallOnInitialLoad,
} from "../../../common_nextgen/utils/UtilFunctions";
import { IndicatorCell } from "../../../common_nextgen/common_components/IndicatorCell/IndicatorCell";

const useDeductibleSchedule = (
  onSelect,
  hideModal,
  initialSelectParams,
  intialSelectMode,
  initialLookupType,
  selectModeParamData,
  onNavigate
) => {
  const location = useLocation();
  const { axios_helper_no_header } = useAxios();
  const {
    ADD_DEDUCTIBLE_SCHEDULE,
    EDIT_DEDUCTIBLE_SCHEDULE,
    DISPLAY_DEDUCTIBLE_SCHEDULE,
    COPY_DEDUCTIBLE_SCHEDULE,
    DEDUCTIBLE_SCHEDULE_NOTE,
    DEDUCTIBLE_SCHEDULE_STEPS,
  } = ROUTE_PATHS;

  const stateVal = location.state ?? [];
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);

  previousState.splice(stateVal.length - 1, 1);

  const {
    selectedSchedules = [],
    previousScreen = "",
    currentIndex: initialIndex = 0,
    paramsData: initialParamsData = {
      dscScheduleName: "",
      hiddenRecordIndicator: "Active",
    },
  } = currentState;

  const [selectMode, setSelectedMode] = useState(intialSelectMode);
  const [lookupType, setLookupType] = useState(initialLookupType);
  const [selectParams, setSelectParams] = useState(initialSelectParams);
  const [disabledDropdowns, setDisabledDropdowns] = useState({});

  const initialParams = selectMode
    ? { ...selectModeParamData, hiddenRecordIndicator: "Active" }
    : initialParamsData;

  const [data, setData] = useState([]); /* Deductible Schedule Data */
  const [paramsData, setParamsData] = useState(initialParams); /* */
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  // const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [isHideConfirmationModalOpen, setIsHideConfirmationModalOpen] =
    useState(false);
  const [hideSelectedOption, setHideSelectedOption] = useState("no");
  const [hideFlag, setHideFlag] = useState(false);
  const toast = useToast();
  const screen_title = "Deductible Schedule";
  // const screenNumber = "RCDSC001";

  /* Param Key which used as bridge between various operations on tabular data */
  const parmKey = "dscScheduleName";
  const statusKey = "hiddenRecordIndicator";

  console.log(selectedRows, "selectedRows");

  const screenNumber = selectMode ? "RCDSC005" : "RCDSC001";

  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  const selectedSchedulesData = selectedRows.length ? selectedRows : [rowData];
  const lastScheduleName =
    selectedSchedulesData[selectedSchedulesData.length - 1]?.dscScheduleName;
  const updatedParamsData = {
    ...paramsData,
    dscScheduleName: lastScheduleName,
  };
  /* Search form fields that needs to be shown for filtering */
  const formFields = selectMode
    ? [
      {
        fieldLabel: "DSC Schedule Name",
        name: "dscScheduleName",
        label: "Schedule",
        type: "text",
        value: "",
        maxLength: 10,
      },
      {
        fieldLabel: "Hidden Record IndicatorValid Values",
        name: "hiddenRecordIndicator",
        label: "Status",
        type: "dropdown",
        value: "",
        maxLength: 1,
      },
    ]
    : [
      {
        fieldLabel: "DSC Schedule Name",
        name: "dscScheduleName",
        label: "Schedule",
        type: "text",
        value: "",
        maxLength: 10,
      },
      {
        fieldLabel: "Hidden Record IndicatorValid Values",
        name: "hiddenRecordIndicator",
        label: "Status",
        type: "dropdown",
        value: "",
        maxLength: 1,
      },
    ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [
    { field_label: "Hidden Record Indicator", condition: "Valid Values" },
  ];
  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const handleBack = () => {
    if (lookupType === "external" && selectMode) {
      window.parent.postMessage(
        {
          type: "hideModal",
        },
        "*"
      );
    } else {
      hideModal();
    }
  };

  const leftButtons = selectMode
    ? [{ button_label: "Back", button_handeler: handleBack, button_key: "F12" }]
    : [];

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = selectMode
    ? [
      {
        button_label: "Export as CSV",
        button_handeler: () => {
          exportAsCSV();
        },
        button_key: "",
      },
    ]
    : [
      {
        button_label: "Add Deductible Schedule",
        button_handeler: () => {
          navigateToPage(ADD_DEDUCTIBLE_SCHEDULE, [
            {
              selectedSchedules: selectedRows.length
                ? selectedRows
                : [rowData],
              previousScreen: location.pathname,
              currentIndex: 0,
            },
          ]);
        },
        button_key: "F6",
      },
      {
        button_label: "Export as CSV",
        button_handeler: () => {
          exportAsCSV();
        },
        button_key: "",
      },
    ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = useMemo(() => {
    return selectMode
      ? [
        {
          label: "Select",
          icon: <span className="material-icons">add</span>,
          command: () => {
            // const [latestPreviousState] = previousState.splice(
            //   previousState.length - 1,
            //   1
            // );
            // let { paramsData } = latestPreviousState;
            // console.log("paramsData", paramsData, latestPreviousState);

            // const updatedParamsData={...paramsData,bmdScheduleCode:rowData[parmKey], bmdDescription:rowData[bmdDescription]};

            // const updatedParamsData={...paramsData,aocScheduleOverride:rowData[parmKey]};
            // const updatedLatestPreviousState={...latestPreviousState,initialParamsData:updatedParamsData}
            // navigateToPage(previousScreen,[...previousState,updatedLatestPreviousState])
            const paramDataMap = new Map();
            selectParams.forEach((key) => {
              if (rowData.hasOwnProperty(key["target"])) {
                paramDataMap.set(key["source"], rowData[key["target"]]);
              }
            });
            const paramData = Object.fromEntries(paramDataMap);
            if (lookupType !== "external") {
              onSelect(paramData);
            } else {
              window.parent.postMessage(
                { type: "responseData", data: paramData },
                "*"
              );
            }
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            /* const message = {
              message: "navigate-to-presto",
              programCode: "RCDSC002I",
              parameters: {
                dscScheduleName: rowData["dscScheduleName"],
              },
            };
            console.log(message, "message");
            window.top.postMessage(message, "*");
            */
            if (lookupType !== "external") {
              onNavigate({
                navType: "local",
                data: rowData,
                target: ROUTE_PATHS.DISPLAY_DEDUCTIBLE_SCHEDULE,
                schedulesDataKey: "selectedSchedules",
                additionalData: {
                  paramsData: {},
                },
              });
            } else {
              const message = {
                type: "navigateData",
                data: { ...rowData },
                target: "DEDUCTIBLE_SCHEDULE_READ_ONLY",
                schedulesDataKey: "selectedSchedules",
              };
              console.log("display message", message);
              window.parent?.postMessage(message, "*");
            }
          },
        },
        {
          label: "Steps",
          icon: <span className="material-icons">search</span>,
          command: () => {
            /*const message = {
              message: "navigate-to-presto",
              programCode: "RCDSD001I",
              parameters: {
                dscScheduleName: rowData["dscScheduleName"],
                dscBasis: rowData["dscBasis"],
                dscDescription: rowData["dscDescription"],
                dscStepCount: rowData["dscStepCount"],
                wrkDescription25: "",
              },
            };
            console.log(message, "message");
            window.top.postMessage(message, "*");*/
            if (lookupType !== "external") {
              onNavigate({
                navType: "local",
                data: rowData,
                target: ROUTE_PATHS.DEDUCTIBLE_SCHEDULE_STEPS,
                schedulesDataKey: "selectedSchedules",
                additionalData: {
                  paramsData: {},
                },
              });
            } else {
              const message = {
                type: "navigateData",
                data: { ...rowData },
                target: "DEDUCTIBLE_SCHEDULE_STEPS",
                schedulesDataKey: "selectedSchedules",
              };
              console.log("display message", message);
              window.parent?.postMessage(message, "*");
            }
          },
        },
      ]
      : [
        {
          label: "Note",
          icon: <span className="material-icons">note</span>,
          command: () => {
            navigateToPage(DEDUCTIBLE_SCHEDULE_NOTE, [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                currentIndex: 0,
              },
            ]);
          },
        },
        {
          label: "Edit",
          icon: <span className="material-icons">edit</span>,
          command: () => {
            navigateToPage(EDIT_DEDUCTIBLE_SCHEDULE, [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                currentIndex: 0,
              },
            ]);
          },
        },
        {
          label: "Copy",
          icon: <span className="material-icons">content_copy</span>,
          command: () => {
            navigateToPage(COPY_DEDUCTIBLE_SCHEDULE, [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                currentIndex: 0,
              },
            ]);
          },
        },
        {
          label: "Delete",
          icon: <span className="material-icons">delete</span>,
          command: () => {
            openConfirmationModal();
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            navigateToPage(DISPLAY_DEDUCTIBLE_SCHEDULE, [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },

              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                currentIndex: 0,
              },
            ]);
          },
        },
        {
          label: "Steps",
          icon: <span className="material-icons">search</span>,
          command: () => {
            navigateToPage(DEDUCTIBLE_SCHEDULE_STEPS, [
              {
                ...currentState,
                paramsData: updatedParamsData,
                currentIndex: currentIndex,
              },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                currentIndex: 0,
              },
            ]);
          },
        },
        {
          label: rowData[statusKey] === "Hidden" ? "Unhide" : "Hide",
          icon: <span className="material-icons">visibility_off</span>,
          command: () => {
            openHideConfirmationModal();
          },
        },
      ];
  }, [rowData]);

  /* Data table column info. */
  const columnDef = [
    {
      header: "Schedule",
      field: "dscScheduleName",
    },
    {
      header: "Description",
      field: "dscDescription",
    },
    {
      header: "Basis",
      field: "dscBasis",
      style: { width: "5%" },
    },
    {
      header: "Steps",
      field: "dscStepCount",
      style: { width: "5%" },
    },
    {
      header: "Indicators",
      field: "noteExistenceStatus",
      body: (rowData) => (
        <IndicatorCell
          rowData={rowData}
          fields={[
            "noteExistenceStatus",
          ]}
          tooltipContent={{
            noteExistenceStatus: "Notes",
          }}
        />
      ),
    },
    {
      header: "Status",
      field: "hiddenRecordIndicator",
      style: { width: "5%" },
    },
  ];

  /* Handler that fetches the data */
  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/dscDeductibleSchCtrl`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);

        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchDataCallOnInitialLoad(fetchData, lookupType);
  }, [paramsData, rows, currentPage, hideFlag, lookupType]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const openHideConfirmationModal = () => {
    setIsHideConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const closeHideConfirmationModal = () => {
    console.log(hideSelectedOption);
    setIsHideConfirmationModalOpen(false);
    setHideSelectedOption("no");
  };

  const hideUnhideDeductibleSchedule = () => {
    if (hideSelectedOption === "yes") {
      const params = {
        dscScheduleName: rowData[parmKey],
        screenNumber: screenNumber,
      };
      axios_helper_no_header(
        "PUT",
        "api/dscDeductibleSchCtrl/hideUnhide",
        null,
        params
      )
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setHideFlag(!hideFlag);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          fetchDataCallOnInitialLoad(fetchData, lookupType);
          closeHideConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error hiding/unhiding the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeHideConfirmationModal();
        });
    } else {
      closeHideConfirmationModal();
    }
  };

  const deleteDeductibleSchedule = () => {
    if (selectedOption === "yes") {
      const params = { dscScheduleName: rowData[parmKey] };
      axios_helper_no_header("DELETE", "api/dscDeductibleSchCtrl", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
          closeConfirmationModal();
        })
        .catch((error) => {
          const {
            responseStatus: { displayErrorFields = null, message } = {},
          } = error.data;
          console.error("There was an error deleting the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData, screenNumber: screenNumber };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/dscDeductibleSchCtrl/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  useEffect(() => {
    const handleMessage = (event) => {
      const { type, data } = event.data;
      if (type === "initData") {
        const externalData = data?.data || {};
        setSelectedMode(data?.selectMode);
        setLookupType("external");
        setParamsData({
          ...paramsData,
          dscScheduleName: externalData?.paramsData?.dscScheduleName || "",
        });
        setSelectParams(externalData?.params);
        setDisabledDropdowns({ hiddenRecordIndicator: true });
      }
    };
    window.addEventListener("message", handleMessage);

    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    selectMode,
    statusKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteDeductibleSchedule,
    setSelectedOption,
    hideUnhideDeductibleSchedule,
    isHideConfirmationModalOpen,
    closeHideConfirmationModal,
    setHideSelectedOption,
    disabledDropdowns,
  };
};

export default useDeductibleSchedule;
